export default (user) => {
    if (!user) return '';
    if (user.ac && user.ac.ADMINS_CONTROL_PANEL) {
        if (user.ac.ADMINS_CONTROL_PANEL.READ)
            return { ...user, isAdmin: true };
    }
    return { ...user, isAdmin: false };

};